import * as React from 'react';
export const IcEmvcoTapPay = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 4C6.48 4 2 7.58 2 12s4.48 8 10 8 10-3.58 10-8-4.48-8-10-8zm-6.12 8.82a1 1 0 01-1 .73 1.26 1.26 0 01-.28 0 1 1 0 01-.6-1.28.75.75 0 000-.54 1.003 1.003 0 011.93-.55 2.86 2.86 0 010 1.64h-.05zm3.85 1.1a1 1 0 01-1 .73.9.9 0 01-.28 0 1 1 0 01-.69-1.24 4.79 4.79 0 000-2.74 1.003 1.003 0 011.93-.55 7 7 0 010 3.84l.04-.04zM13.57 15a1 1 0 01-1 .73c-.09.01-.18.01-.27 0a.999.999 0 01-.69-1.24 8.89 8.89 0 000-4.94A1.018 1.018 0 0113.57 9a10.82 10.82 0 010 6zm3.84 1.1a1 1 0 01-1 .72c-.09.01-.18.01-.27 0a.999.999 0 01-.69-1.24 12.75 12.75 0 000-7.14 1 1 0 011.447-1.149 1 1 0 01.473.599 14.68 14.68 0 010 8.24l.04-.03z'
      fill='currentColor'
    />
  </svg>
);
